import { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { enrollModal, selectType, showModal } from "../../redux/actions";
import { courseEnrollmentWithSession, getAllUsersDetail, getDashboardAllPlan, getDimensionUpdatePlan, getLifePlan, getPlanSchedule, getUserPlan, updateLearnerPlan } from "../../redux/actions/APIs";
import * as image from "../../resources/images";
import {
	convertedNumber,
	getCalculatePlanDate,
	getCalenderViewData,
	getCapitalized,
	getCurrentDaysOfWeek,
	getdateWithCurretnTime,
	getUrlSegment
} from "../../utils/helper";
import DeletePlanActivities from "../learnerplan/DeletePlanActivities";
const EnrollmenHalfScreen = ({ closeModal, courseData }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { loggedInUser, defaultChildData, planCourseGoalData, modalData, response, mySelectType, planScheduleData, courseEnrollResponse } =
		useSelector((state) => state.collections);
	const [courseType, setCoursetype] = useState(mySelectType ? mySelectType : "enroll");
	const [calenderData, setCalenderData] = useState([]);
	const [getDayOfWeek, setDayOfWeek] = useState();
	const [selectedMinutes, setSelectedMinutes] = useState(30);
	const [selectedSitting, setSelectedSitting] = useState(2);
	const [selectedTimeZone, setSelectedTimeZone] = useState(0);
	const [userDate, setUserDate] = useState(new Date());
	const [selctedDays, setSeleccted] = useState([]);
	const [isFlexible, setIsFlexible] = useState(false);
	const [getFlexibLeDays, setFlexibLeDays] = useState([]);
	const [deletePlan, setDeletePlan] = useState();
	const [courseIndex, setCourseIndex] = useState(
		courseData[0]?.courseIndex ? courseData[0]?.courseIndex : 0
	);
	const [minDate, setMinDate] = useState(new Date());

	const [selectedUser, setSelectedUser] = useState();
	const [getPreviousPlan, setPreViousPlan] = useState(false);
	const [loader, setLoader] = useState(false);


	useEffect(() => {
		if (loggedInUser) {
			let getmyUser = loggedInUser?.children?.find((user) => user?.id === courseData[0]?.childId);
			if (getmyUser) {
				setSelectedUser(getmyUser);
			} else {
				setSelectedUser(courseData[0]?.childId);
			}
		}
	}, [loggedInUser])

	let sittings = ["1", "2", "3", "4", "5", "6", "7"];
	let minutes = ["15", "30", "45", "60"];
	let weekDays = [
		{ value: "Monday", key: "Mon" },
		{ value: "Tuesday", key: "Tue" },
		{ value: "Wednesday", key: "Wed" },
		{ value: "Thursday", key: "Thu" },
		{ value: "Friday", key: "Fri" },
		{ value: "Saturday", key: "Sat" },
		{ value: "Sunday", key: "Sun" },
	];

	const weeks = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
	const timezoneObj = [
		{ key: "US/Eastern (ET)", value: "US/Eastern" },
		{ key: "US/Central (CT)", value: "US/Central" },
		{ key: "US/Mountain (MT)", value: "US/Mountain" },
		{ key: "US/Pacific (PT)", value: "US/Pacific" },
	];


	useEffect(() => {
		if (courseType === "enroll") {
			handleFlexible()
			let getCurentDays = getCurrentDaysOfWeek(userDate, selectedSitting);
			handleSavePlan(getCurentDays);
		}
		if (courseType === "edit" && courseData?.length > 0) {
			handleFlexible();
		}
	}, [])


	useEffect(() => {
		if ((courseType === "edit" && planScheduleData?.records?.length > 0 && courseData?.length === 0 || getPreviousPlan)) {
			let tempPlanData = planScheduleData?.records[0];
			let getCurentDayOfWeek = tempPlanData?.dayOfWeek ? tempPlanData?.dayOfWeek?.split(",") : ["Mon", "Tue"];
			courseData = tempPlanData?.courses;
			courseData[0].planName = tempPlanData?.name ? tempPlanData?.name : "Custom Plan";
			courseData[0].planId = tempPlanData?.planId;
			courseData[0].childId = defaultChildData?.id;
			dispatch(enrollModal(courseData));
			setSelectedSitting(tempPlanData?.sittings);
			setSelectedMinutes(tempPlanData?.duration);
			setUserDate(new Date(tempPlanData?.planStartDate));
			setMinDate(new Date(tempPlanData?.planStartDate))
			setSeleccted(getCurentDayOfWeek);
			setPreViousPlan(false);
		}
	}, [planScheduleData])



	const handleSavePlan = (getCurentDays) => {
		if (!getCurentDays && selctedDays?.length === 0 && getFlexibLeDays?.length === 0) {
			setDeletePlan({ title: "Select Days", message: `Please select one of the options for the days your child will do coursework.You can select ‘I’m Flexible’ if you are not sure. ` })
			return;
		} else if (!getCurentDays && selctedDays?.length != selectedSitting && getFlexibLeDays?.length != selectedSitting) {
			setDeletePlan({
				title: "Select Days", message: `Please select ${selectedSitting - selctedDays?.length} more day${(selectedSitting - selctedDays?.length) > 1 ? 's' : ''}.`
			})
			return;
		}
		if (courseData) {
			let weekArr = getCurentDays?.length > 0 ? getCurentDays : getFlexibLeDays?.length > 0 ? getFlexibLeDays : selctedDays;
			let enrollCourseData = handleCalculateStartDateEndDate(courseData, selectedSitting, selectedMinutes, weekArr, courseData[0]?.planName);

			if (courseType === "enroll") {
				if (enrollCourseData?.courses?.length === 1) {
					dispatch(courseEnrollmentWithSession(courseData[0]?.childId, courseData[0]?.skill?.id, courseData[0]?.id, enrollCourseData));
				} else {
					dispatch(updateLearnerPlan(courseData[0]?.childId, loggedInUser?.id, enrollCourseData))
				}
			} else {
				dispatch(getDimensionUpdatePlan(loggedInUser?.id, enrollCourseData));
			}
			if(!getCurentDays){
				setLoader(true);
			}
		}
		
	}

	const viewPlanEnroll = () => {
		if (selctedDays?.length === 0 && getFlexibLeDays?.length === 0) {
			setDeletePlan({ title: "Select Days", message: `Please select one of the options for the days your child will do coursework.You can select ‘I’m Flexible’ if you are not sure. ` })
			return;
		} else if (selctedDays?.length != selectedSitting && getFlexibLeDays?.length != selectedSitting) {
			setDeletePlan({
				title: "Select Days", message: `Please select ${selectedSitting - selctedDays?.length} more day${(selectedSitting - selctedDays?.length) > 1 ? 's' : ''}.`
			})
			return;
		}
		let weekArr = getFlexibLeDays?.length > 0 ? getFlexibLeDays : selctedDays;
		let enrollCourseData = handleCalculateStartDateEndDate(courseData, selectedSitting, selectedMinutes, weekArr, courseData[0]?.planName);
		setCoursetype("enroll");
		dispatch(updateLearnerPlan(courseData[0]?.childId, loggedInUser?.id, enrollCourseData))
		dispatch(selectType());
	}

	//   useEffect(() => {
	//     if (courseData) {
	//       dispatch(getPlanCourseGoal(courseData[0]?.childId, courseData[0]?.planId));
	//       //    let enrollCourseData = handleCalculateStartDateEndDate(courseData[0], 2, 30, ["Mon", "Thu"], courseData[0]?.name);
	//       //         dispatch(courseEnrollmentWithSession(courseData[0]?.childId, courseData[0]?.skillId, courseData[0]?.id, enrollCourseData));
	//     }
	//   }, []);

	const handleCalculateStartDateEndDate = (
		courses,
		sitting,
		duration,
		planDays,
		planName
	) => {
		let getPlanDateArr = getCalculatePlanDate(
			courses?.length > 0 ? courses : [courses],
			duration,
			sitting,
			userDate,
			planDays
		);
		if (getPlanDateArr.length > 0) {
			let array = {
				name: planName ? planName : courses[0]?.name,
				sittings: sitting,
				duration: duration,
				planCount: 1,
				timeZone: loggedInUser?.timeZone
					? loggedInUser?.timeZone
					: timezoneObj[selectedTimeZone]?.value,
				planType: courseData[courseIndex]?.planType,
				planId: courseData[courseIndex]?.planId,
				userId: courseData[courseIndex]?.childId,
				iscourseupdate: true,
				daysOfWeek: planDays,
				courses: getPlanDateArr,
			};
			return array;
		}
	};

	useEffect(() => {
		if (courseData?.length > 0 && (getFlexibLeDays?.length > 0 || selctedDays?.length > 0)) {
			// let weekDayArr = getCurentDayOfWeek?.length > 0 ? getCurentDayOfWeek :
			//     getFlexibLeDays?.length > 0 ? getFlexibLeDays : selctedDays
			// console.log('courseData : ', courseData, courseData[0]);
			let weekArr = getFlexibLeDays?.length > 0 ? getFlexibLeDays : selctedDays;

			let enrollCourseData = handleCalculateStartDateEndDate(
				courseData,
				selectedSitting,
				selectedMinutes,
				weekArr,
				courseData[0]?.planName
			);
			dispatch(
				showModal({
					type: "",
					data: enrollCourseData?.courses,
					getUserTimeZone: enrollCourseData?.timeZone,
					dayOfWeek: enrollCourseData?.daysOfWeek,
					holidays: [],
				})
			);
		}
	}, [courseData[courseIndex], selectedSitting, selectedMinutes, getFlexibLeDays, selctedDays, userDate]);

	// console.log("enrollment halfAScreen ", selectedSitting, selectedMinutes, getFlexibLeDays, selctedDays, response);
	useEffect(() => {
		if (modalData?.data?.length > 0) {
			let calenderArr = getCalenderViewData(modalData);
			let calenderSesonsData = calenderArr?.filter((week) =>
				week?.find((item) => item?.courseName)
			);
			setCalenderData(calenderSesonsData);
			if (courseType === "edit") {
                setPreViousPlan(true);
            }
			// let seqWeekDay = weeks?.filter((wkDay) => modalData?.dayOfWeek?.find((day) => wkDay === day))
			// setDayOfWeek(seqWeekDay);
		}
	}, [modalData]);

	const handleSitting = (value) => {
		setSelectedSitting(value)
		setFlexibLeDays([]);
		setSeleccted([]);
		setIsFlexible(false);
		// calculateUpcomingDays(value);
		let getCurentDays = getCurrentDaysOfWeek(userDate, 1);
		setSeleccted(getCurentDays);
	}

	const handleMinutes = (value) => {
		setSelectedMinutes(value)
		if (courseData?.length === 1 &&
			value == "60" && ["5", "6", "7"]?.includes(selectedSitting)) {
			setSelectedSitting(4);
			handleFlexible(4);
		}
	}
	const handleWeekDays = (weekKey, index) => {
		if (courseType === "enroll") {
			return;
		}
		if (
			selctedDays?.length >= selectedSitting &&
			!selctedDays?.includes(weekKey)
		) {
			setDeletePlan({
				title: "Select Days",
				message: `You have already selected ${selectedSitting} days for ${selectedSitting} sessions.`,
			});
			return;
		}
		let daysOfArr = [...selctedDays];
		const key = daysOfArr?.findIndex((item) => item === weekKey);
		if (key !== -1) {
			daysOfArr?.splice(key, 1);
		} else {
			daysOfArr?.push(weekKey);
		}
		setSeleccted(daysOfArr);
		setIsFlexible(false);
		if (daysOfArr?.length > 0) {
			setFlexibLeDays([]);
		} else {
			handleFlexible(selectedSitting);
		}
	};
	const handleSelectedCourse = (corInd) => {
		// console.log("courseData @@ Inn: ", courseData, corInd);
		if (corInd >= 0 && corInd < 4) {
			setCourseIndex(corInd);
		}
	};

	const handleFlexible = (val) => {
		setSeleccted([]);
		setIsFlexible(!isFlexible);
		if (!isFlexible) {
			calculateUpcomingDays(val ? val : selectedSitting);
		} else {
			//	setFlexibLeDays([]);
		}
	}

	const calculateUpcomingDays = (value) => {
		let weekArr = [];
		let currentDate = new Date(userDate);
		for (let i = 0; i < value; i++) {
			let weekDay = new Date(currentDate).toLocaleString("en-us", { weekday: 'short' });
			weekArr?.push(weekDay);
			currentDate.setDate(currentDate.getDate() + 1);
		}
		setFlexibLeDays(weekArr);
	}

	const closePlan = () => {
		setDeletePlan();
	}

	const PreviousPlan = () => {
        if (getPreviousPlan) {
            dispatch(getPlanSchedule(courseData[0].childId, courseData[0].planId));
        }
    
    }

	const handleCloseHalfScreen = () => {
		if (!mySelectType && courseType === "edit") {
			setCoursetype("enroll");
			PreviousPlan();
		} else {
			dispatch(selectType());
			closeModal();
		}
	}

	useEffect(() => {
        if (courseEnrollResponse?.success && calenderData?.length > 0) {
            let getmyUser = loggedInUser?.children?.find((user) => user?.id === courseData[0]?.childId);
            if (!getmyUser?.isUserPlan) {
				dispatch(getAllUsersDetail());
			}
        }
    },[courseEnrollResponse])

	useEffect(() => {
        if ((response?.success || courseEnrollResponse?.success) && calenderData?.length > 0) {
			setLoader(false);
            let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : courseData[0]?.childId;
            if (getUrlSegment()[0] === "home") {
                dispatch(getDashboardAllPlan(courseData[0]?.childId));
            } else if(getUrlSegment()[0] === "userplan") {
                dispatch(getUserPlan(userId, courseData[0]?.childId));
				dispatch(getLifePlan());
            }
            if (courseType === "edit") {
                // handleCloseHalfScreen();
                dispatch(getPlanSchedule());
                dispatch(updateLearnerPlan());
				dispatch(getLifePlan());
                dispatch(selectType());
                closeModal();
            }
        }
    }, [response, courseEnrollResponse])

	return (
		<div className="smallpopup calendarSchedule RootContent">
			<div className="modal d-flex" id="schoolactivity3" role="dialog">
				<div className="">
					<div className="modal-content my_popup halfscreen_popup">
						<div className="modal-header">
							<h2 className="flexone w-100">
								<span>📝 {courseData[0]?.planName ? courseData[0]?.planName : courseData[0]?.name} Schedule

								</span>
								<button
									className="closebtn"
									data-dismiss="modal"
									onClick={() => handleCloseHalfScreen()}
								>
									<i class="fa-regular fa-xmark"></i>
								</button>
							</h2>
						</div>

						<div className="modal-body paymentinfo p-0">
							{courseType === "enroll" &&
								<h3 className="mt-2 h-3 flexthree congratulationtxt">
									<img src={image.newcheckicon} alt="checkicon" className="mycheckicon mr-4" />
									{/* Congratulations on enrolling {getCapitalized(selectedUser?.firstName)} in {courseData[0]?.planName}. We have used the following recommended
									assumptions to build a custom plan for {getCapitalized(selectedUser?.firstName)} to maximize learning and complete this course. */}
									You’ve successfully enrolled {getCapitalized(selectedUser?.firstName)} in {courseData[0]?.planName ? courseData[0]?.planName : courseData[0]?.name}. Based on recommended settings, we’ve created a personalized schedule to help {getCapitalized(selectedUser?.firstName)} stay on track and make steady progress. You can review and adjust this schedule anytime.
								</h3>
							}
							<div className="editplaninformation mb-0 pb-0 px-0">
								<div className="editplan_title pdb-3">
									<h2 className="w-100 flexone">
										<span>
											Plan Schedule
											<span className="infoicons">
												<img src={image.newinfoicon} alt="" className="newinfoicons ml-3" />
												<div className="mytoottiptxt p-3">
													<p className="p1 mb-1">Select Day Here</p>
													<p className="p2">Select the day’s you want your plan to be scheduled on, pick days in accordance to your session count.</p>
												</div>
											</span>
										</span>
										{courseType === "enroll" ? (
											<p class="p1" onClick={() => setCoursetype("edit")}><a href="#"><i class="fa-solid fa-pencil mr-1"></i>Edit Plan</a></p>
										) : (

											""
										)}
									</h2>
								</div>
								<div className="flexone flex-wrap">
									<ul className="flextwo align-items-baseline flex-wrap">
										<li className=" position-relative">
											<p className="p1">Sessions Per Week:<span class="mandatoryField">*</span></p>
											<p>
												<span
													className="pacetags"
													href="#showUserPlan0"
													data-toggle={courseType === "edit" ? "dropdown" : ""}
													aria-expanded="true"
												>
													{selectedSitting} Sessions{" "} {courseType === "edit" && (
														<span>
															<i class="fa-regular fa-chevron-down"></i>
														</span>

													)}
												</span>

												<ul
													className="dropdown-menu dropdown-menu-end lPDropdwnList"
													aria-labelledby="showUserPlan0"
												>
													{sittings?.map((value, index) => (
														<li
															className={`pacetags 
														${courseData?.length == 1 && ["5", "6", "7"]?.includes(value) && selectedMinutes == "60" && "disabledevent"} `}
															key={index}
															onClick={() => handleSitting(value)}
														>{value} Session</li>
													))}
												</ul>
											</p>
										</li>

										<li className=" position-relative">
											<p className="p1">Duration Per Session:<span class="mandatoryField">*</span></p>
											<p className="position-relative">
												<span
													className="pacetags"
													href="#showUserPlan1"
													data-toggle={courseType === "edit" ? "dropdown" : ""}
													aria-expanded="true"
												>
													{selectedMinutes} Minutes
													{courseType === "edit" && (
														<span>
															<i class="fa-regular fa-chevron-down"></i>
														</span>

													)}

												</span>

												<ul
													className="dropdown-menu dropdown-menu-end lPDropdwnList"
													aria-labelledby="showUserPlan1"
												>
													{minutes?.map((value, index) => (
														<li
															key={index}
															onClick={() => handleMinutes(value)}
														>{value} Minutes</li>
													))}
												</ul>
											</p>
										</li>

										{/* <li className="position-relative">
										<p className="p1">Start Date:</p>
										<p className="position-relative">
											<span
												className="pacetags"
												href="#showUserPlan1"
												data-toggle={courseType === "edit" ? "dropdown" : ""}
												aria-expanded="true"
											>
												{getUsStatnderdTimeWithMonthName(userDate, "US/Eastern")}
												{courseType === "edit" && (
													<span>
														<i class="fa-regular fa-chevron-down"></i>
													</span>

												)}
											</span>
											<ul
												className="dropdown-menu dropdown-menu-end lPDropdwnList"
												aria-labelledby="showUserPlan1"
											>
												<label className={`flexone position - relative w - 100 mt - 0`}>
												<DatePicker className="form-control signupChildClass p-0 w-100"
													clearIcon={null}
													oneTap
													// onChange={(value) => {
													// 	setUserDate(getdateWithCurretnTime(value))
													// }}
													value={userDate}
													dayPlaceholder={"dd"}
													monthPlaceholder={"mm"}
													yearPlaceholder={"yyyy"}
													format="MM/dd/yyyy"
													placement={"topEnd"}
													// minDate={minDate}
													/>
												</label>
											</ul>
										</p>
									</li> */}
										{courseType === "edit" && (
											<li className="position-relative">
												<p className="p1">Start Date:<span class="mandatoryField">*</span></p>
												<p className="position-relative">
													{/* <span
												className="pacetags"
												href="#showUserPlan1"
												data-toggle={courseType === "edit" ? "dropdown" : ""}
												aria-expanded="true"
											>
												{getUsStatnderdTimeWithMonthName(userDate, "US/Eastern")}
												{courseType === "edit" && (
													<span>
														<i class="fa-regular fa-chevron-down"></i>
													</span>

												)}
											</span> */}
													<label className={`flexone position-relative w-100 mt-0 p-0 border-0`}>
														<span className="pacetags p-0">
															<DatePicker className="form-control signupChildClass p-0 w-100"
																clearIcon={null}
																oneTap
																onChange={(value) => {
																	setUserDate(getdateWithCurretnTime(value))
																}}
																value={userDate}
																dayPlaceholder={"dd"}
																monthPlaceholder={"mm"}
																yearPlaceholder={"yyyy"}
																format="MM/dd/yyyy"
																placement={"topEnd"}
																minDate={minDate}
															/>
															<span>
																<i class="fa-regular fa-chevron-down m-0"></i>
															</span>
														</span>

													</label>

												</p>
											</li>
										)}
										<li>
											<div className="flexone align-items-start">
												{!loggedInUser?.timeZone && courseType === "edit" && (
													<div className="plan_Time_Zonedrp position-relative">
														<p className="p1">
															{" "}
															Time Zone:<span class="mandatoryField">*</span>{" "}
														</p>
														<span
															class="pacetags p2"
															href="#showUserPlan1"
															data-toggle="dropdown"
															aria-expanded="true"
														>
															{timezoneObj[selectedTimeZone]?.key}{" "}
															<i class="fa-regular fa-chevron-down"></i>{" "}
														</span>

														<ul
															className="dropdown-menu dropdown-menu-end lPDropdwnList"
															aria-labelledby=""
														>
															{timezoneObj?.map((value, key) => (
																<li onClick={() => setSelectedTimeZone(key)}>
																	{value?.key}
																</li>
															))}
														</ul>
													</div>
												)}
											</div>
										</li>

									</ul>
									<ul>
										<li className="selectflexiblelist">
											<p className="p1">
												Select {convertedNumber(selectedSitting).toLowerCase()}
												({selectedSitting}) Days you want to work on Bloomster.
											</p>
											<div className="defaultpacecheck">
												<div className="Ansoptions checkboxtyped">
													<label className="selAnslabel ">
														<span className="p2 lighttextcolor ">
															I’m Flexible (We select consecutive days including
															‘Start date’ & ‘Sessions per week’).
														</span>
														<input
															type="checkbox"
															name="knowledgecheck"
															checked={isFlexible && selctedDays?.length === 0}
															onClick={() => handleFlexible()}
														/>
														<span class="checkmark"></span>
													</label>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>


							{/* Calendar Days*/}
							{calenderData?.length > 0 && (
								<div className="schedulecalender px-0">
									<div className="flexone w-100 mt-3">
										<div className="calander-days week-day-only">
											<p>Week</p>
										</div>
										{weekDays?.map((day, key) => (
											<div
												className={`calander-days infoicons ${selctedDays?.includes(day?.key) && "week-day-only"} pointer`}
												key={key}
												onClick={() => handleWeekDays(day?.key, key)}
											>
												<p>{day?.value}</p>
												<div className="mytoottiptxt p-3">
													<p className="p1 mb-1">Select Day Here</p>
													<p className="p2">Select the day’s you want your plan to be scheduled on, pick days in accordance to your session count.</p>
												</div>
											</div>
										))}


									</div>



									{/* Calendar Date */}

									{/* 1 secion */}
									{calenderData?.map((weeks, index) => {
										const currentWeek = weeks?.find((item) => item?.courseName);
										return (
											<div className="flexone w-100 mt-3">
												<div className="calander-date-min-div week" key={index}>
													<div className="calander-date-title week-date-title ">
														<p className="p3">
															{weeks[0]?.date} - {weeks[6]?.date}
														</p>

													</div>
													<p className="pt-4 p2 fw-500 weekName ">
														Week {index + 1}

														{/* <img src={image.newinfoicon} alt="" className="newinfoicons ml-3" /> */}


													</p>
												</div>
												{weeks?.map((days, key) => (
													<>
														{days?.courseName ? (
															<div className="calander-date-min-div active-date">
																<div className="calander-date-title active-date-title">
																	<p className="p3">{days?.date}

																	</p>

																</div>
																<div className="d-flex justify-content-start pl-2 position-relative">
																	<p className="pt-4 p4 fw-500 calander-date-sub-title calender_name" >
																	<span className="">C{days.courseKey}: {days?.courseName}</span>
																		
																	</p>
																	<div class="mytoottiptxt p-3">
																		<p class="">{days?.courseName}</p>
																	 </div>
																</div>
																<div className="d-flex justify-content-start pt-2 pl-2 position-relative" >
																	<i
																		className="fa fa-caret-right mr-1"
																		aria-hidden="true"
																	></i>
																	<p className="calander-date-sub-title1  p3 text-uppercase calender_name">
																		<span className="">M{days?.moduleKey}: {days?.moduleName}</span>
																    	
																	</p>
																	<div class="mytoottiptxt p-3">
																		<p class=""> {days?.moduleName}</p>
																	 </div>
																</div>
															</div>
														) : (
															<div key={key} className="calander-date-min-div">
																<div className="calander-date-title">
																	<p className="p3">{days?.date}</p>
																</div>
																<p className="pt-4 p2 fw-500"></p>
															</div>
														)}
													</>
												))}
											</div>
										);
									})}
								</div>
							)}
						</div>
						<div class="modal-footer ">
												<div class="text-right">
													<button
														type="button"
														class="mybutton learnmore flexfive"
														onClick={() => handleCloseHalfScreen()}
													>
														<i class="fa-regular fa-circle-xmark mr-1"></i>	Cancel
													</button>
												</div>
												{courseType === "edit" && (
													<>
													 {loader ? (
														<span>
														<div class="text-right">
															<button
																	className=" mybutton"
																	key={Math.random()}
																	disabled
																>
																	<span className="RounAnimation mr-1"></span>{" "}
																	Please Wait...
															</button>
														</div>
														</span>

														) : !planScheduleData && !courseEnrollResponse ? (
														<div class="text-right">
															<button
																type="button"
																class="mybutton flexfive"
																onClick={() => viewPlanEnroll()}
															>
																<i class="fa-regular fa-circle-check mr-1"></i>	Save & Enroll
															</button>
														</div>
														) : (
															<div class="text-right">
																<button
																	type="button"
																	class="mybutton flexfive"
																	onClick={() => handleSavePlan()}
																>
																	<i class="fa-regular fa-circle-check mr-1"></i>	Save
																</button>
															</div>
													)}
													</>
												)}
											</div>
						{/* <div className="modal-footer">
                    <div className="text-right">
                            <button
                            type="button"
                            className="mybutton"
                            >
                            Continue
                            </button>
                    </div>
                    </div> */}
					</div>
				</div>
			</div>
			{deletePlan && (
				<DeletePlanActivities
					closePlan={closePlan}
					deletePlan={deletePlan}
				/>
			)}
		</div>
	);
};
export default EnrollmenHalfScreen;